import { css, type Theme } from '@emotion/react';

export const containerStyle = (theme: Theme) => css`
  width: 100%;
  text-decoration: none;

  display: flex;
  align-items: center;

  border-radius: 8px;

  padding: 4px;

  color: ${theme.colors.gray[700]};

  transition: ${theme.transitions.default()};

  &.isCollapsed {
    justify-content: center;
  }

  &:not(.isDisabled) {
    &:hover {
      background-color: ${theme.colors.gray[50]};
    }

    &.isSelected {
      background-color: ${theme.colors.primary[100]};
      color: ${theme.colors.primary[600]};
    }
  }

  &.isDisabled {
    color: ${theme.colors.gray[300]};

    &.isSelected {
      background-color: ${theme.colors.gray[25]};
    }
  }
`;

export const iconContainer = (theme: Theme) => css`
  padding: 4px;

  display: flex;
  align-items: center;

  flex: none;

  transition: ${theme.transitions.default()};
`;

export const labelStyle = (theme: Theme) => css`
  margin: 4px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  flex: 1;

  transition: ${theme.transitions.default('margin-left', 'margin-right')};
`;

export const iconBadgeContainerStyle = css`
  position: relative;
`;

export const badgeStyle = css`
  position: absolute;
  left: -10px;
  top: -10px;
`;

export const dot = (theme: Theme) => css`
  position: absolute;
  right: -5px;
  bottom: -5px;
  width: 12px;
  height: 12px;
  border: 2px solid ${theme.colors.gray[0]};
  border-radius: 100%;
  background-color: ${theme.colors.danger[500]};
`;

export const tagsStyle = css`
  display: flex;
  align-items: center;
  gap: 4px;

  margin-top: 2px;
`;

export const moreTagsStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const more = (theme: Theme) => css`
  color: ${theme.colors.primary[500]};
  text-decoration: underline;
`;

export const getIconFills = (theme: Theme, isDisabled: boolean, isSelected: boolean) => {
  if (isDisabled) {
    return isSelected
      ? [theme.colors.gray[0], theme.colors.gray[200]]
      : [theme.colors.gray[200], theme.colors.gray[25]];
  }

  return isSelected
    ? [theme.colors.primary[600], theme.colors.primary[100]]
    : [theme.colors.gray[500], theme.colors.gray[50]];
};

export const dragStyle = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  cursor: grab;

  padding: 2px;
`;

export const label = css`
  width: 100%;

  &.isSelected {
    letter-spacing: 0.021em;
  }
`;
